import React from 'react';
import styled from 'styled-components';

import Ticker from "../uiComponents/TickerComponent";
import { Oval } from "react-loader-spinner"

const getCurrencySymbol = (currency: string) => {
    switch(currency) {
        case 'USD':
            return '$';
        case 'EUR':
            return '€';
        case 'GBP':
            return '£';
        case 'JPY':
            return '¥';
        case 'CNY':
            return '¥';
        case 'KRW':
            return '₩';
        case 'INR':
            return '₹';
        case 'RUB':
            return '₽';
        case 'BRL':
            return 'R$';
        default:
            return '$';
    }
}

const Balance = styled.div`
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 500;
    font-size: 36px;
    text-align: center;
    color: #FFFFFF;
    margin-top: 87px;
    display: flex;
    justify-content: center;
`;


const currencyToIndexMapping: any = {
    'USD': 0,
    'INR': 1,
    'BRL': 2,
}

const getCurrencyAmountFromItem = (item: any, currency:any) => {
    // ${parseFloat(Number(item.exchange[0].value).toFixed(6))}
    switch(currency) {
        case 'USD':
            return `${getCurrencySymbol(currency)}${parseFloat(Number( (item.exchange && item.exchange[0]) ? item.exchange[0].value : 0).toFixed(2))}`;
        case 'INR':
            return `${getCurrencySymbol(currency)}${parseFloat(Number((item.exchange && item.exchange[1]) ? item.exchange[1].value : 0).toFixed(2))}`;
        case 'BRL':
            return `${getCurrencySymbol(currency)}${parseFloat(Number((item.exchange && item.exchange[1]) ? item.exchange[1].value : 0).toFixed(2))}`;
    }
}    

const getAmount = (item:any, currency:any) => {
    if(!item.exchange) {
        return 0;
    }
    switch(currency){
        case 'USD':
            return parseFloat(Number(item.exchange[0].value).toFixed(2));
        case 'INR':
            return parseFloat(Number(item.exchange[1].value).toFixed(2));
        case 'BRL':
            return parseFloat(Number(item.exchange[2].value).toFixed(2));
    }
}

const BalanceComponent = (props: any) => {

    const [totalBalance,  setTotalBalance] = React.useState(0);
    
    React.useEffect(() => {
        let totalBalance = 0;
        for(let i=0; i< props.nonNFTTokensList.length;i++){
            let val:any = getAmount(
                props.nonNFTTokensList[i],
                props.currency);
            totalBalance += val;
        }
        setTotalBalance(totalBalance);
    }, [props.nonNFTTokensListLen, props.currency]);
    
    return (
        <>
          {(props.nonNFTTokensList.length) ? 
           <>
             <Ticker 
                 symbol={getCurrencySymbol(props.currency)}
                 amount={totalBalance.toFixed(2)}
             />
           </>
          :
           <Balance>
             <Oval
                 ariaLabel="loading-indicator"
                 height={40}
                 width={40}
                 color="white"
                 wrapperClass=""
                 visible={true}
                 secondaryColor="#ffffff"
                 strokeWidth={4}
                 strokeWidthSecondary={4}
             />
           </Balance>
          }
        </>
    );
}

export default BalanceComponent;
